import { withinPrefix } from '@/components/layout/use-active-section'

/**
 * True on `/brokers` and every Broker Analysis page under it — Overview, By broker, Compare, the
 * lists, Reviews, Last minute movers and whatever joins them — where the mock draws the Broker rail
 * (Today's highlights + Top rated brokers) in place of the shared Market news + Popular stocks.
 */
export const isBrokerRoute = (pathname: string): boolean => withinPrefix(pathname, '/brokers')
